import React, {Component} from 'react';
import {NavLink} from 'reactstrap';
import {Link} from 'react-router-dom';
import authService from './AuthorizeService';
import {ApplicationPaths} from './ApiAuthorizationConstants';

export class LoginMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: false,
            userName: null,
            name:''
        };
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }

    async populateState() {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        this.setState({
            isAuthenticated,
            userName: user && user.name
        });
        const token = await authService.getAccessToken()
        const username_response = await fetch('api/validator/getUsername', {
            headers: !token ? {} : {'Authorization': `Bearer ${token}`}})
        const username = await username_response.json()
        this.setState({name: username.userName})
    }

    render() {

        const {isAuthenticated, userName} = this.state;
        if (!isAuthenticated) {
            const registerPath = `${ApplicationPaths.Register}`;
            const loginPath = `${ApplicationPaths.Login}`;
            return this.anonymousView(registerPath, loginPath);
        } else {
            const profilePath = `${ApplicationPaths.Profile}`;
            const logoutPath = {pathname: `${ApplicationPaths.LogOut}`, state: {local: true}};
            return this.authenticatedView(userName, profilePath, logoutPath);
        }
    }

    authenticatedView(userName, profilePath, logoutPath) {
        return (<div>
            <div className="user-name-row">{this.state.name}</div>
            <NavLink tag={Link} className="username" activeclassname="active" to='/profile'>Личный кабинет</NavLink>
            <NavLink tag={Link} className="log-button" activeclassname="active" to={logoutPath}>Выход</NavLink>
        </div>);

    }

    anonymousView(registerPath, loginPath) {
        return (<div>
            <NavLink tag={Link} className="log-button" activeclassname="active" to={loginPath}>Вход</NavLink>
        </div>
        );
    }


}
